import React from 'react';
import { Layout, Menu, message, Grid } from 'antd';
import { Link, useNavigate } from 'react-router';
import { UserOutlined } from '@ant-design/icons';
import { useAuth } from '../providers/AuthProvider';
import { useMutation } from '@apollo/client';
import { LOG_OUT } from '../graphql/mutations/mutations';
import { IMenuItem } from '../types/menu';
import {
  headerStyle,
  contentStyle,
  mobileContentStyle,
  layoutStyle,
  logoStyle,
} from './LoggedLayout.styles';
import { USER_MENU_ITEMS } from '../consts/menu';
import { RoleSwitcher } from '../components/Navigation/RoleSwitcher';
import { ProjectProgress } from '../modules/project';

const { Header, Content } = Layout;
const { useBreakpoint } = Grid;

interface UserProjectLayoutProps {
  children: React.ReactNode;
}

export const UserProjectLayout: React.FC<UserProjectLayoutProps> = ({ children }) => {
  const { removeAuthUser } = useAuth();
  const navigate = useNavigate();
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const [logout] = useMutation(LOG_OUT, {
    onCompleted: data => {
      if (data?.LogOut) {
        removeAuthUser();
        message.success('Logged out successfully');
        navigate('/login');
      }
    },
    onError: error => {
      message.error(error.message || 'Logout failed');
    },
  });

  const buildUserMenuItems = (): IMenuItem[] => {
    const userMenuItems: IMenuItem[] = USER_MENU_ITEMS.map(item => {
      if (item.key === '/logout') {
        return {
          ...item,
          onClick: () => logout(),
        };
      }

      return {
        ...item,
        label:
          typeof item.label === 'string' && item.key !== '/logout' ? (
            <Link to={item.key || '/'}>{item.label}</Link>
          ) : (
            item.label
          ),
      };
    });

    return userMenuItems;
  };

  const menuItems: IMenuItem[] = [
    {
      key: 'logo',
      disabled: true,
      style: { pointerEvents: 'none', marginRight: 'auto' },
      label: <img src="/public/images/logo_circle.png" alt="menu" style={logoStyle} />,
    },
    {
      key: 'role-switcher',
      disabled: true,
      style: { cursor: 'default', backgroundColor: 'transparent' },
      label: <RoleSwitcher />,
    },
    {
      key: 'user-menu',
      label: <UserOutlined />,
      children: buildUserMenuItems(),
    },
  ];

  return (
    <Layout style={layoutStyle}>
      <Header
        style={{
          ...headerStyle,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
        <div style={{ display: 'flex', alignItems: 'center', width: 'auto', paddingRight: '20px' }}>
          <img src="/public/images/logo_circle.png" alt="menu" style={logoStyle} />
        </div>

        {!isMobile && (
          <div style={{ flex: 1, display: 'flex', paddingLeft: '20px', paddingRight: '20px' }}>
            <ProjectProgress />
          </div>
        )}

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            width: '250px',
            justifyContent: 'flex-end',
          }}>
          {/* <RoleSwitcher /> */}
          <Menu
            theme="light"
            mode="horizontal"
            items={[
              {
                key: 'user-menu',
                label: <UserOutlined />,
                children: buildUserMenuItems(),
              },
            ]}
            style={{ borderBottom: 'none', minWidth: '60px', justifyContent: 'flex-end' }}
          />
        </div>
      </Header>

      <Content style={!isMobile ? contentStyle : mobileContentStyle}>{children}</Content>
    </Layout>
  );
};
